export default "<div></div>\n<input #chatInput type=\"text\" placeholder=\"Chat\">\n";